import secureLocalStorage from "react-secure-storage";
import { CircularProgress, Select } from "@material-ui/core";
import {
  Grid,
  GridColumn as Column,
  GridToolbar,
} from "@progress/kendo-react-grid";
import React, { Component } from "react";
import { toastr } from "react-redux-toastr";
import Api from "../../Services/Api";
import "../../Styles/Admin.scss";
import Images from "../../Assets/Images";
import { Popup } from "@progress/kendo-react-popup";
import { ComboBox } from "@progress/kendo-react-dropdowns";
import { Checkbox } from "@progress/kendo-react-inputs";
import { MultiSelect } from "@progress/kendo-react-dropdowns";

export default class CustomField extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      assignedValues: [],
      loader: false,
      skip: 0,
      take: 10,
      saveFlag: false,
      openDeleteModelFlag: false,
      currentRowId: 0,
      allowCustom: false,
      inputType: undefined,
      isUserList: false,
      userListArray: [],
      value: [],
      allSelected: true,
    };
    // this.assignValue = this.assignValue.bind(this);
  }

  inputTypeList = [
    "Free Text",
    "Numeric",
    "Date",
    "Single Drop Down",
    "Multi Drop Down",
  ];

  componentDidMount() {
    this.getCustomField();
    this.getUserList();
  }
  pageChange = (event) => {
    this.setState({
      skip: event.page.skip,
      take: event.page.take,
    });
  };
  addNew = () => {
    this.setState({
      ...this.state,
      saveFlag: true,
      assignedValues: [],
      fieldName: "",
      fieldValue: "",
      currentRowId: 0,
    });
  };
  removeValue = (index) => {
    let array = this.state.assignedValues;
    // const index = array.indexOf(i);
    if (index > -1) {
      array.splice(index, 1);
    }
    this.setState({
      ...this.state,
      assignedValues: array,
    });
  };
  cancel = () => {
    this.setState({
      ...this.state,
      saveFlag: false,
      inputType: undefined,
      value:[],
      isUserList:false
    });
  };
  itemChange = (event) => {
    const data = this.state.data.map((item) =>
      item.id === event.dataItem.id
        ? { ...item, [event.field]: event.value }
        : item
    );

    this.setState({ data });
  };

  capitalizeFirstLetter = (str) => {
    return str.charAt(0).toUpperCase() + str.slice(1);
  };

  assignValue = () => {
    this.state.assignedValues.push(this.state.fieldValue.trim());
    let arr1 = this.state.assignedValues.reduce((result, element) => {
      var normalize = (x) => (typeof x === "string" ? x.toLowerCase() : x);

      var normalizedElement = normalize(element);
      if (
        result.every(
          (otherElement) => normalize(otherElement) !== normalizedElement
        )
      )
        result.push(element);
      return result;
    }, []);
    this.setState({
      ...this.state,
      assignedValues: arr1,
      fieldValue: "",
    });
  };

  saveAssignedValues = async () => {
    try {
      if (!this.state.fieldName || this.state.fieldName.trim() === "") {
        toastr.error("Name is required");
        return;
      }
      let request = {
        FieldName: this.state.fieldName.trim(),
        inputType: this.state.inputType,
        PossibleValues: this.state.assignedValues,
        CreatedBy: parseInt(secureLocalStorage.getItem("loginUserId")),
        IsUserList: this.state.isUserList,
        IsAllUser: this.state.value.some((item) => item.text === "Select All"),
        UserList: this.state.value.map((item) => item.value),
      };
      this.setState({ loader: true });
      let response = await Api.addCustomField(request);
      this.setState({ loader: false });
      if (response.status === 200) {
        toastr.success(response.message);
        this.cancel();
        this.getCustomField();
      } else {
        toastr.error(response.message);
      }
    } catch (err) {
      console.error(err);
    }
  };

  updateCustomField = async () => {
    try {
      if (!this.state.fieldName || this.state.fieldName.trim() === "") {
        toastr.error("Name is required");
        return;
      }
      let request = {
        Id: this.state.currentRowId,
        FieldName: this.state.fieldName.trim(),
        inputType: this.state.inputType,
        PossibleValues: this.state.assignedValues,
        CreatedBy: parseInt(secureLocalStorage.getItem("loginUserId")),
        IsUserList: this.state.isUserList,
        IsAllUser: this.state.value.some((item) => item.text === "Select All"),
        UserList: this.state.value.map((item) => item.value),
      };
      this.setState({ loader: true });
      let response = await Api.updateCustomField(request);
      this.setState({ loader: false });
      if (response.status === 200) {
        toastr.success(response.message);
        this.cancel();
        this.getCustomField();
      } else {
        toastr.error(response.message);
      }
    } catch (err) {
      console.error(err);
    }
  };
  deleteCustomField = async () => {
    try {
      let request = {
        Id: this.state.currentRowId,
        DeletedBy: parseInt(secureLocalStorage.getItem("loginUserId")),
      };
      this.setState({ loader: true });
      let response = await Api.deleteCustomField(request);
      this.setState({ loader: false });
      if (response.status === 200) {
        toastr.success(response.message);
        this.deleteFieldClose();
        this.getCustomField();
      } else {
        toastr.error(response.message);
      }
    } catch (err) {
      console.error(err);
    }
  };
  getCustomField = async () => {
    try {
      let request = {
        CreatedBy: parseInt(secureLocalStorage.getItem("loginUserId")),
      };
      this.setState({ loader: true });
      let response = await Api.getCustomField(request);
      if (response.status === 200) {
        this.setState({
          ...this.state,
          data: response.customFields,
          loader: false,
        });
      } else {
        this.setState({
          ...this.state,
          data: [],
          loader: false,
        });
      }
    } catch (err) {
      console.error(err);
    }
  };

  getUserList = async () => {
    try {
      let response = await Api.getuserAddedByTenant();
      if (response.status === 200) {
        var tempUserList = [{ value: 0, text: "Select All" }];
        for (var i = 0; i < response.tenantUsers.length; i++) {
          tempUserList.push({
            value: response.tenantUsers[i].userId,
            text: response.tenantUsers[i].name,
          });
        }
        this.setState({
          ...this.state,
          userListArray: tempUserList,
        });
      } else {
        this.setState({
          ...this.state,
          userListArray: [],
        });
      }
    } catch (err) {
      console.error(err);
    }
  };

  editField = (row) => {
    this.setState({
      ...this.state,
      saveFlag: true,
      currentRowId: row.dataItem.id,
      fieldName: row.dataItem.fieldName,
      assignedValues: row.dataItem.isUserList===true?[]:[...row.dataItem.possibleValues],
      inputType: row.dataItem.inputType,
      isUserList: row.dataItem.isUserList,
      value: this.getUserListByIds(row.dataItem.userList,row.dataItem.isAllUser),
    });
  };
  getUserListByIds = (userIds,isAllUser) => {
    let userList = [];
    try {
      if (userIds&&isAllUser===false) {
        userList = this.state.userListArray.filter((user) =>
          userIds.includes(user.value)
        );
      }else if(userIds&&isAllUser===true){
        userList = this.state.userListArray;
      }
    } catch (err) {
      console.error(err);
    }
    return userList;
  };
  deleteFieldOpen = (row) => {
    this.setState({
      openDeleteModelFlag: true,
      currentRowId: row.dataItem.id,
    });
  };

  deleteFieldClose = () => {
    this.setState({ openDeleteModelFlag: false, currentRowId: 0 });
  };
  handleChange = (event) => {
    this.setState({
      inputType: event.target.value,
    });
  };
  getInputType() {
    let arr = this.inputTypeList;
    if (
      this.state.currentRowId != 0 &&
      this.state.inputType === "Single Drop Down"
    ) {
      return this.inputTypeList.filter((item) => item === "Multi Drop Down");
    }
    return arr;
  }
  handleChangeUserList = (event) => {
    try {
      let currentStateValue = [...this.state.value];
      let difference = [];
      if (event.target.value.length > currentStateValue.length) {
        difference = event.target.value.filter(
          (item1) =>
            !currentStateValue.some((item2) => item2.value === item1.value)
        );
      } else {
        difference = currentStateValue.filter(
          (item1) =>
            !event.target.value.some((item2) => item2.value === item1.value)
        );
      }
      if (difference.some((item) => item.text === "Select All")) {
        if (this.state.allSelected) {
          this.setState({
            value: [],
            allSelected: false,
          });
        } else {
          this.setState({
            value: this.state.userListArray,
            allSelected: true,
          });
        }
      } else {
        if (
          this.state.userListArray.length - 1 === event.value.length &&
          !this.state.allSelected
        ) {
          this.setState({
            value: this.state.userListArray,
            allSelected: true,
          });
        } else {
          let value = event.target.value.filter((item) => {
            return item.text !== "Select All";
          });
          this.setState({
            value: value,
            allSelected: false,
          });
        }
      }
    } catch (err) {
      console.log(err);
    }
  };
  itemRender = (li, itemProps) => {
    const itemChildren = (
      <span>
        <input
          type="checkbox"
          name={itemProps.dataItem}
          checked={itemProps.selected}
          onChange={(e) => itemProps.onClick(itemProps.index, e)}
        />
        &nbsp;{li.props.children}
      </span>
    );
    return React.cloneElement(li, li.props, itemChildren);
  };
  render() {
    const value = this.state.value;
    const selected =value.some((item) => item.text === "Select All")?value.length-1: value.length;
    return (
      <div className="riskTypeCont">
        {this.state.loader ? (
          <span className="MatTableSpinner">
            <CircularProgress style={{ color: "#FFFFFF" }} size={70} />
          </span>
        ) : null}

        {this.state.saveFlag && (
          <div className="rm-tanent-cont">
            <div className="rm-form-cont customFieldFormCont relPosition">
              <form name="form">
                <div className="row">
                  <div className="col-xs-12 col-sm-8">
                    <div className="row customFieldForm">
                      <div className="col-xs-12 col-sm-12 mb-2">
                        <h5>Add Custom Field</h5>
                      </div>
                      <div
                        className="col-xs-12 col-sm-3 col-md-3"
                        style={{ paddingLeft: "25px" }}
                      >
                        <div className="rm-form customFieldContainer">
                          <div className="field-container">
                            <label>Field Name</label>
                            <input
                              value={this.state.fieldName}
                              type="text"
                              name="name"
                              autoComplete="off"
                              onChange={(e) => {
                                this.setState({
                                  ...this.state,
                                  fieldName: e.target.value,
                                });
                              }}
                              className="form-control"
                            />
                          </div>
                            <span className="errMsg">{this.state.fieldName.includes('.')?"Custom Field Name must not contain '.'":""}</span>
                        </div>
                      </div>
                      <div className="col-xs-12 col-sm-2 col-md-2">
                        <div className="rm-form customFieldContainer">
                          <div className="field-container">
                            <label>Select Input Type</label>
                            <ComboBox
                              data={this.getInputType()}
                              // allowCustom={this.allowCustom}
                              value={this.state.inputType}
                              onChange={this.handleChange}
                              disabled={
                                this.state.currentRowId != 0 &&
                                this.state.inputType !== "Single Drop Down"
                              }
                            />
                          </div>
                        </div>
                      </div>
                      {/* start */}
                      {this.state.inputType == "Multi Drop Down" ||this.state.inputType == "Single Drop Down" ? (
                        <div className="col-xs-2 col-sm-2 col-md-2 exportuser">
                          <Checkbox
                            label={"Is User List"}
                            value={this.state.isUserList}
                            onChange={(e) => {
                              this.setState({
                                ...this.state,
                                isUserList: e.value,
                              });
                            }}
                          />
                        </div>
                      ) : (
                        ""
                      )}

                      {this.state.isUserList === true ? (
                        <div className="col-xs-12 col-sm-3 col-md-3">
                          <div className="rm-form customFieldContainer">
                            <div className="field-container">
                              <label>Select User</label>
                              <MultiSelect
                                onChange={this.handleChangeUserList}
                                value={value}
                                data={this.state.userListArray}
                                itemRender={this.itemRender}
                                valueField="value"
                                textField="text"
                                filterable={false}
                                autoClose={false}
                                tags={
                                  selected > 0
                                    ? [
                                        {
                                          text: `${selected} items selected`,
                                          data: [...value],
                                        },
                                      ]
                                    : []
                                }
                              />
                            </div>
                          </div>
                        </div>
                      ) : (
                        ""
                      )}

                      {(this.state.inputType == "Multi Drop Down" ||
                        this.state.inputType == "Single Drop Down") &&
                      this.state.isUserList === false ? (
                        <>
                          <div className="col-xs-12 col-sm-3 col-md-3">
                            <div className="rm-form customFieldContainer">
                              <div className="field-container">
                                <label>Enter Drop Down Values</label>
                                <input
                                  value={this.state.fieldValue}
                                  type="text"
                                  name="name"
                                  autoComplete="off"
                                  onChange={(e) => {
                                    this.setState({
                                      ...this.state,
                                      fieldValue: e.target.value,
                                    });
                                  }}
                                  className="form-control"
                                  //   placeholder="Enter Field Name"
                                />
                              </div>
                            </div>
                          </div>
                          <div
                            className="col-xs-12 col-sm-2 col-md-2 alignBtnBottom"
                            style={{ paddingRight: "35px" }}
                          >
                            <button
                              type="button"
                              disabled={
                                !this.state.fieldValue || !this.state.fieldName 
                              }
                              onClick={this.assignValue}
                              className="cus-btn-primary"
                              style={{ position: "relative", top: "-2px" }}
                            >
                              Add
                            </button>
                          </div>
                        </>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                  {(this.state.inputType == "Multi Drop Down" ||
                    this.state.inputType == "Single Drop Down") &&
                  this.state.isUserList === false ? (
                    <>
                      <div
                        className="col-xs-12 col-sm-4"
                        style={{ marginTop: "35px" }}
                      >
                        <div className="row">
                          <div className="col-sm-12 ">
                            <ul>
                              <label>Entered Values</label>
                              {this.state.assignedValues.map((item, index) => (
                                <li>
                                  {" "}
                                  {item}&nbsp;&nbsp;
                                  <a>
                                    <img
                                      src={Images.CLOSE}
                                      onClick={() => this.removeValue(index)}
                                      alt="Download"
                                      width="14"
                                    />
                                  </a>
                                </li>
                              ))}
                            </ul>
                          </div>
                        </div>
                      </div>
                    </>
                  ) : (
                    ""
                  )}
                </div>

                <div className="d-flex justify-content-end mt-2">
                  <button
                    type="button"
                    // onClick={this.saveAssignedValues}
                    disabled={
                      !this.state.inputType|| !this.state.fieldName || (this.state.isUserList===true&&this.state.value.length==0) || this.state.fieldName.includes('.')
                    }
                    onClick={
                      this.state.currentRowId != 0
                        ? this.updateCustomField
                        : this.saveAssignedValues
                    }
                    className="rm-btn-primary"
                  >
                    {this.state.currentRowId != 0 ? "Update" : "Submit"}
                  </button>
                  <button
                    className="rm-btn-primary"
                    type="button"
                    onClick={this.cancel}
                  >
                    Cancel
                  </button>
                </div>
              </form>
            </div>
          </div>
        )}
        <div className="dbCard card100 noPadd">
          <div className="gridBox">
            <div className="tblCont dataGrids noPaddTop">
              <div className="rw-tab-content customField" id="admincustomField">
                <Grid
                  data={this.state.data.slice(
                    this.state.skip,
                    this.state.take + this.state.skip
                  )}
                  onItemChange={this.itemChange}
                  pageable={true}
                  reorderable
                  resizable
                  skip={this.state.skip}
                  take={this.state.take}
                  total={this.state.data.length}
                  onPageChange={this.pageChange}
                >
                  {!this.state.saveFlag && (
                    <GridToolbar className="customHeader">
                      <div className="gridHeader">
                        <div className="d-flex align-items-center">
                          <h4>Custom Field</h4>
                          <div className="ml-auto d-flex">
                            <div className="btnGreen noMargin">
                              <button onClick={this.addNew}>Add Field</button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </GridToolbar>
                  )}

                  <Column field="fieldName" width="150px" title="Field Name" />
                  <Column
                    field="possibleValues"
                    title="Possible Values"
                    width="748px"
                    cell={(props) => (
                      <td title={props.dataItem.possibleValues}>
                        {props.dataItem.possibleValues.map((item, index) => (
                          <span>
                            {item}
                            {props.dataItem.possibleValues.length - 1 != index
                              ? ","
                              : ""}
                          </span>
                        ))}
                      </td>
                    )}
                  />
                  <Column width="160px" field="inputType" title="Input Type" />

                  <Column
                    width="70px"
                    title="Actions"
                    cell={(row) => (
                      <td className="k-grid-content-sticky actionsBtns">
                        <ul className="actionIcon">
                          <li>
                            <a
                              title="Edit"
                              className="greenbtn icon"
                              onClick={() => this.editField(row)}
                            >
                              <img
                                src={Images.EDITICON}
                                width="10"
                                alt="edit"
                              />
                            </a>
                          </li>
                          <li>
                            <a
                              title="Delete"
                              className="redbtn icon"
                              onClick={() => this.deleteFieldOpen(row)}
                            >
                              <img src={Images.TRASH} width="12" alt="Trash" />
                            </a>
                          </li>
                        </ul>
                      </td>
                    )}
                  />
                </Grid>
              </div>
            </div>
          </div>
        </div>

        <Popup
          show={this.state.openDeleteModelFlag}
          popupClass={"popup-content"}
        >
          {this.state.loader ? (
            <span className="MatTableSpinner">
              <CircularProgress style={{ color: "#FFFFFF" }} size={70} />
            </span>
          ) : null}
          <div className="deleteModelCont">
            <h3>Are you sure you want to delete this field?</h3>
            <div className="btnCont">
              <button
                onClick={() => this.deleteCustomField()}
                className="deleteBtn"
              >
                Delete
              </button>
              <button onClick={this.deleteFieldClose} className="cancelBtn">
                Cancel
              </button>
            </div>
          </div>
        </Popup>
      </div>
    );
  }
}
